import { isKnownRole, type ExtranetRole } from '../../domain/access';

interface RoleVisualTokens {
  bg: string;
  text: string;
}

export const ROLE_COLORS: Record<ExtranetRole, RoleVisualTokens> = {
  Extranet_Admin: { bg: 'bg-violet-50', text: 'text-violet-700' },
  Extranet_Achat: { bg: 'bg-blue-50', text: 'text-blue-700' },
  Extranet_Commande: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  Extranet_Facturation: { bg: 'bg-amber-50', text: 'text-amber-700' },
};

const ROLE_FALLBACK_COLOR: RoleVisualTokens = { bg: 'bg-zinc-100', text: 'text-zinc-700' };

/** Tout rôle inconnu du front tombe sur le fallback neutre. */
export const getRoleColor = (role: string): RoleVisualTokens =>
  isKnownRole(role) ? ROLE_COLORS[role] : ROLE_FALLBACK_COLOR;
